import {useState} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const CopyableField = ({ text, variant = "h6", fontWeight = "regular" }) => {
  const [showButton, setShowButton] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <MDBox
      display="flex"
      alignItems="top"
      onClick={handleCopy}
      onMouseEnter={() => setShowButton(true)}
      onMouseLeave={() => setShowButton(false)}
      sx={{ cursor: "pointer", width: "fit-content" }}
    >
      {/* Inputted Text */}
      <MDTypography variant={variant} fontWeight={fontWeight}>
        {text}
      </MDTypography>

      {/* Copy Button */}
      <MDBox ml={1} sx={{ visibility: showButton ? "visible" : "hidden" }}>
        <Tooltip title={copied ? "Copied!" : "Copy"} placement="top" arrow>
          <ContentCopyIcon fontSize="small" color={copied ? "success" : "inherit"} />
        </Tooltip>
      </MDBox>
      
    </MDBox>
  );
};